import { DocumentNode } from '@apollo/client';

import { useQuery } from '@ts-core/lib/apollo';
import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import {
  getSubjectsByCourseQuery,
  GetSubjectsByCourseQueryResult,
  GetSubjectsByCourseQueryVariables,
} from '../graphql/queries/getSubjectsByCourseQuery';
import { CoreSubject } from '../types';

export interface SubjectsHookInput {
  courseId?: string;
  subjectsTreeFragment: DocumentNode;
}

export interface SubjectsHookOutput<TSubject> {
  subjects?: TSubject[];
  loading: boolean;
  error?: string;
}

export default function useSubjects<TSubject = CoreSubject>(input: SubjectsHookInput): SubjectsHookOutput<TSubject> {
  const { courseId, subjectsTreeFragment } = input;

  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error } = useQuery<GetSubjectsByCourseQueryResult<TSubject>, GetSubjectsByCourseQueryVariables>(
    getSubjectsByCourseQuery(subjectsTreeFragment),
    {
      variables: {
        courseId: courseId || '',
      },
      skip: !courseId,
      onError: showErrorNotification,
    }
  );

  return {
    loading,
    subjects: data?.subjects,
    error: getErrorMessage({ error }),
  };
}
